<template>
  <div class="tab-pane" :class="{ 'active': show }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TabbedPortletBodyTab',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>
